import { IconButton } from 'bz-core-controls/controls/next/menu';
import type { IProps as IIconButtonProps } from 'bz-core-controls/controls/next/menu/icon-button';
import React from 'react';
import Secure from 'tm3-core/controls/security/secure';

export interface IProps extends Omit<IIconButtonProps, 'action'> {
  action?: string;
}

export default class extends React.Component<IProps> {
  static defaultProps = {
    style: { position: 'absolute', right: 50, top: 4 },
    iconStyle: { position: 'absolute', right: 50, top: 4 },
    action: ''
  };

  render() {
    const { children, action, ...rest } = this.props;
    const button = <IconButton {...rest}>{children}</IconButton>;
    if (!action) {
      return button;
    }

    return <Secure rules={[action]}>{button}</Secure>;
  }
}
